import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import Menu from './Menu';
import { FaLinkedin } from 'react-icons/fa';
import { HeaderProps, MenuItem } from '../types';
import { BiSolidFileDoc } from 'react-icons/bi';

const Header: React.FC<HeaderProps> = ({ className = '' }) => {
  const location = useLocation();

  const handleLinkClick = (e: React.MouseEvent<HTMLAnchorElement>, path: string): void => {
    if (location.pathname === path) {
      e.preventDefault();
    }
  };

  const menuItems: MenuItem[] = [
    {
      label: 'About Us',
      to: '/about-us'
    },
    {
      label: 'Solutions',
      to: '/solutions',
    },
    {
      label: 'Products',
      children: [
        
        {
          label: 'Customer Relationship Management',
          to: '/products/crm'
        },
        {
          label: 'Revenues Management',
          to: '/products/revenues'
        },
        {
          label: 'Expenses & Procurement Management',
          to: '/products/expenses'
        },
        {
          label: 'Inventory Management',
          to: '/products/inventory'
        },
          {
            label: 'HR Management',
            to: '/products/hrms'
          },
          {
            label: 'Clinic Management',
            to: '/products/clinic'
          },
          {
            label: 'Point of Sales (POS)',
            to: '/products/pos'
          }
      ]
    },
    // {
    //   label: 'Pricing',
    //   to: '/pricing'
    // },
    // {
    //   label: 'Downloads',
    //   to: '/downloads'
    // },
    {
      label: 'Portfolios',
      to: '/portfolios'
    },
    {
      label: 'Contact',
      to: '/contact'
    },
    {
      label: 'Blogs',
      to: '/blog'
    },
    {
      label: 'Documentations',
      href: 'https://docs.akas.co/'
    }
  ];

  return (
    <header className={`bg-white shadow-md sticky top-0 z-50 relative ${className}`}>
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex items-center justify-between h-20">
          <div className="flex flex-1 items-center">
            <div className="flex-shrink-0 flex items-center">
              <Link to="/" onClick={(e) => handleLinkClick(e, '/')}>
                <img 
                  className="block h-20 w-auto" 
                  src="/images/akas-logo.png" 
                  alt="AKAS" 
                />
              </Link>
            </div>
            <Menu items={menuItems} />
          </div>
          
          <div className="flex items-center">
            <div className="hidden xl:ml-4 xl:flex-shrink-0 xl:flex xl:items-center">
              <a 
                href="https://facebook.com/www.akas.co" 
                target="_blank" 
                rel="noopener noreferrer" 
                className="text-gray-500 hover:text-primary p-1"
              >
                <span className="sr-only">Facebook</span>
                <svg className="h-6 w-6" fill="currentColor" viewBox="0 0 24 24">
                  <path 
                    fillRule="evenodd" 
                    d="M22 12c0-5.523-4.477-10-10-10S2 6.477 2 12c0 4.991 3.657 9.128 8.438 9.878v-6.987h-2.54V12h2.54V9.797c0-2.506 1.492-3.89 3.777-3.89 1.094 0 2.238.195 2.238.195v2.46h-1.26c-1.243 0-1.63.771-1.63 1.562V12h2.773l-.443 2.89h-2.33v6.988C18.343 21.128 22 16.991 22 12z" 
                    clipRule="evenodd" 
                  />
                </svg>
              </a>
            </div>
            <div className="hidden xl:ml-4 xl:flex-shrink-0 xl:flex xl:items-center">
              <a 
                href="https://www.linkedin.com/company/akas-co/" 
                target="_blank" 
                rel="noopener noreferrer" 
                className="text-gray-500 hover:text-primary p-1"
              >
                <span className="sr-only">LinkedIn</span>
                <FaLinkedin size={24} />
              </a>
            </div>
            <div className="hidden xl:ml-4 xl:flex-shrink-0 xl:flex xl:items-center">
              <a 
                href="https://docs.akas.co/" 
                target="_blank" 
                rel="noopener noreferrer" 
                className="text-gray-500 hover:text-primary p-1"
              >
                <span className="sr-only">Documentations</span>
                <BiSolidFileDoc size={28} />
              </a>
            </div>
          </div>
        </div>
      </div>
    </header>
  );
};

export default Header; 